var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chat-message"},[_c('ChatBubble',{staticClass:"chat-message__bubble",attrs:{"message":_vm.message}}),_c('CatIcon',{staticClass:"chat-message__icon",attrs:{"size":_vm.catIconSize,"writerType":_vm.writerType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }